// Workspace security: the section page in features/security/security-page.tsx.

import { createFileRoute } from "@tanstack/react-router";
import { useSecurity } from "@/api/security";
import { PageError, PageLoading, useRetry } from "@/components/page-states";
import { SecurityPage } from "@/features/security/security-page";

export const Route = createFileRoute("/w/$workspaceId/security")({
    component: SecurityRoute,
});

function SecurityRoute() {
    const { workspaceId } = Route.useParams();
    const securityQuery = useSecurity(workspaceId);
    const securityRetry = useRetry(securityQuery);
    if (securityRetry.failed) return <PageError level={1} {...securityRetry.props} />;
    if (securityQuery.isLoading || !securityQuery.data) return <PageLoading />;
    return <SecurityPage workspaceId={workspaceId} settings={securityQuery.data} />;
}
